export default from './Project';



// WEBPACK FOOTER //
// ./src/containers/Project/index.js